module.exports = __webpack_public_path__ + "static/media/012.699c1c4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/012.jpg
// module id = 359
// module chunks = 0